import { render, staticRenderFns } from "./PolizaDecesos.vue?vue&type=template&id=11e75890&scoped=true&"
import script from "./PolizaDecesos.vue?vue&type=script&lang=js&"
export * from "./PolizaDecesos.vue?vue&type=script&lang=js&"
import style0 from "./PolizaDecesos.vue?vue&type=style&index=0&id=11e75890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e75890",
  null
  
)

export default component.exports